import React from 'react';
import tw from 'twin.macro';
import { HomeIcon } from 'containers/Sequences/icons/HomeIcon';
import { FolderIcon } from 'containers/Sequences/icons/FolderIcon';
import { SequenceIcon } from 'containers/Sequences/icons/SequenceIcon';
import { FDPIcon } from 'containers/Sequences/icons/FDPIcon';
import { CycleIcon } from 'containers/UserSettings/BulletinOfficielPage/Bo/icons/CycleIcon';
import { MatiereIcon } from 'containers/UserSettings/BulletinOfficielPage/Bo/icons/MatiereIcon';
import { DomaineIcon } from 'containers/UserSettings/BulletinOfficielPage/Bo/icons/DomaineIcon';
import { CompetenceIcon } from 'containers/UserSettings/BulletinOfficielPage/Bo/icons/CompetenceIcon';
import { ObjectifIcon } from 'containers/UserSettings/BulletinOfficielPage/Bo/icons/ObjectifIcon';

export type TreeIcons =
  | 'root'
  | 'folder-close'
  | 'folder-open'
  | 'document'
  | 'collection'
  | 'cycle'
  | 'matiere'
  | 'domaine'
  | 'competence'
  | 'objectif'
  | null
  | undefined;

interface Props {
  icon?: TreeIcons;
}

const getStyle = [tw`shrink-0 mr-1 size-6`];

export default function NodeIcon(props: Props) {
  const { icon } = props;
  if (!icon) {
    return null;
  }
  if (icon === 'root') {
    return <HomeIcon css={[getStyle]} />;
  }
  if (icon === 'folder-close') {
    return <FolderIcon css={[getStyle]} />;
  }
  if (icon === 'collection') {
    return <SequenceIcon css={getStyle} />;
  }
  if (icon === 'document') {
    return <FDPIcon css={getStyle} />;
  }
  if (icon === 'cycle') {
    return <CycleIcon css={getStyle} />;
  }
  if (icon === 'matiere') {
    return <MatiereIcon css={getStyle} />;
  }
  if (icon === 'domaine') {
    return <DomaineIcon css={getStyle} />;
  }
  if (icon === 'competence') {
    return <CompetenceIcon css={getStyle} />;
  }
  if (icon === 'objectif') {
    return <ObjectifIcon css={getStyle} />;
  }
  return null;
}
